import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Pending Expulsion' },
    { value: 1, label: 'Written Notice of Potential Expulsion' },
    { value: 2, label: 'Notice of Decision to Expel' },
    { value: 3, label: 'Expelled' },
    { value: 4, label: 'Not Expelled' },
  ],
});
